/* eslint-disable */
import { useState } from "react";
import {

  Typography,
  Button,
 
  Box,
  TextField,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
 
} from "@mui/material";
 const AddRawMaterialDialog = ({ open, onClose, onSave }) => {
  const [materialName, setMaterialName] = useState("");
  const [materialAttributes, setMaterialAttributes] = useState([{ key: "", value: "" }]);

  const handleAddAttribute = () => {
    setMaterialAttributes([...materialAttributes, { key: "", value: "" }]);
  };

  const handleAttributeChange = (index, field, value) => {
    const newAttributes = [...materialAttributes];
    newAttributes[index][field] = value;
    setMaterialAttributes(newAttributes);
  };

  const handleSave = () => {
    if (!materialName.trim()) {
      alert("Please enter a material name");
      return;
    }
    const newMaterial = {
      product: { id: Date.now().toString(), name: materialName },
      variant: { attributes: Object.fromEntries(
        materialAttributes.filter(attr => attr.key && attr.value)
          .map(attr => [attr.key, attr.value])
      )}
    };
    onSave(newMaterial);
    setMaterialName("");
    setMaterialAttributes([{ key: "", value: "" }]);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Add New Raw Material</DialogTitle>
      <DialogContent>
        <TextField
          label="Material Name"
          value={materialName}
          onChange={(e) => setMaterialName(e.target.value)}
          fullWidth
          margin="normal"
          autoFocus
        />
        <Typography variant="subtitle2" gutterBottom sx={{ mt: 2 }}>
          Attributes
        </Typography>
        {materialAttributes.map((attr, index) => (
          <Box key={index} sx={{ display: 'flex', gap: 1, mb: 1 }}>
            <TextField
              label="Key"
              value={attr.key}
              onChange={(e) => handleAttributeChange(index, 'key', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
            />
            <TextField
              label="Value"
              value={attr.value}
              onChange={(e) => handleAttributeChange(index, 'value', e.target.value)}
              size="small"
              sx={{ flex: 1 }}
            />
          </Box>
        ))}
        <Button
          variant="outlined"
          onClick={handleAddAttribute}
          sx={{ mt: 1 }}
        >
          Add Attribute
        </Button>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined">
          Cancel
        </Button>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={!materialName.trim()}
        >
          Save Material
        </Button>
      </DialogActions>
    </Dialog>
  );
};


export default AddRawMaterialDialog;